<template>
  <label class="Vue-NoFeedback">
    <input type="checkbox" v-model="checked"/>
    {{ label }}
  </label>
</template>

<script>
import $ from 'jquery';

export default {
  props: {
    label: String
  },
  data() {
    return {
      checked: false,
      prevValue: '',
    }
  },
  computed: {},
  mounted() {
  },
  watch: {
    checked(value) {
      const textarea = $('[data-question-code="' + window.Predictiv.QUESTION_CODE + '"] .form-control');
      if (value) {
        this.prevValue = textarea.val();
        textarea.hide();
        textarea.val('N/A');
      } else {
        textarea.val(this.prevValue);
        textarea.show();
      }
    }
  },
  methods: {},
  components: {}
}
</script>

<style lang="scss" scoped>
.Vue-NoFeedback {
  margin: 20px;
  cursor: pointer;
}
</style>
